import { render, staticRenderFns } from "./AdminAccountForm.vue?vue&type=template&id=35e16ed3&scoped=true&"
import script from "./AdminAccountForm.vue?vue&type=script&lang=js&"
export * from "./AdminAccountForm.vue?vue&type=script&lang=js&"
import style0 from "./AdminAccountForm.vue?vue&type=style&index=0&id=35e16ed3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e16ed3",
  null
  
)

export default component.exports